import Table from './Table';
import './Table.scss';

export default Table;